import { render, staticRenderFns } from "./EditAnnouncement.vue?vue&type=template&id=68f5ed6e&scoped=true"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5ed6e",
  null
  
)

export default component.exports